import { Pipe, PipeTransform, Inject } from '@angular/core';
import { unitM2Formatter } from '@icc/shared/helpers';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared/config';
import { UserService } from '@icc/shared/user.service';

@Pipe({
    name: 'unitm2',
    standalone: false
})
export class Unitm2Pipe implements PipeTransform {
  constructor(
    @Inject(APP_CONFIG) private config: AppConfigFactory,
    private userService: UserService
  ) {}

  transform(value: any, hasunit = 0, inmm = 0, mb = 0, dimension_unit = '', unitPrefix:string = ''): any {
    return unitM2Formatter(
      value,
      this.config().IccConfig,
      hasunit,
      inmm,
      mb,
      dimension_unit || this.userService.get().dimension_unit || this.config().dimensionUnit,
      unitPrefix
    );
  }

}
